import { render, staticRenderFns } from "./SpecialAttention.vue?vue&type=template&id=6b02da2a"
import script from "./SpecialAttention.vue?vue&type=script&lang=js"
export * from "./SpecialAttention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports